import React from 'react';
import { ArrowDown, ArrowUp, ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

export const PosTable = ({ columns, rows, sort, order, onSort, page, total, pageSize = 50, onPage, onRowClick, loading, testid, empty = 'No records for the selected filters' }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  return (
    <div data-testid={testid}>
      <div className="overflow-x-auto border border-slate-200 rounded-lg bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wide">
            <tr>
              {columns.map((c) => (
                <th key={c.key}
                  onClick={c.sortable !== false && onSort ? () => onSort(c.key) : undefined}
                  className={`px-3 py-2 whitespace-nowrap font-semibold ${c.align === 'right' ? 'text-right' : 'text-left'} ${c.sortable !== false && onSort ? 'cursor-pointer hover:text-slate-900 select-none' : ''}`}
                  data-testid={`${testid}-th-${c.key}`}>
                  <span className="inline-flex items-center gap-1">
                    {c.label}
                    {sort === c.key && (order === 'desc' ? <ArrowDown className="w-3 h-3" /> : <ArrowUp className="w-3 h-3" />)}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={columns.length} className="py-8 text-center text-slate-400">
                <Loader2 className="w-5 h-5 animate-spin inline" />
              </td></tr>
            )}
            {!loading && (!rows || rows.length === 0) && (
              <tr><td colSpan={columns.length} className="py-8 text-center text-slate-400" data-testid={`${testid}-empty`}>{empty}</td></tr>
            )}
            {!loading && rows?.map((r, i) => (
              <tr key={r.customer_id ? `${r.customer_id}-${r.month || i}` : i}
                onClick={onRowClick ? () => onRowClick(r) : undefined}
                className={`border-t border-slate-100 ${onRowClick ? 'cursor-pointer hover:bg-emerald-50/50' : 'hover:bg-slate-50'} transition-colors`}
                data-testid={`${testid}-row-${i}`}>
                {columns.map((c) => (
                  <td key={c.key} className={`px-3 py-1.5 whitespace-nowrap ${c.align === 'right' ? 'text-right tabular-nums' : ''}`}>
                    {c.render ? c.render(r[c.key], r) : (r[c.key] ?? '—')}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {onPage && (
        <div className="flex items-center justify-between mt-2 text-xs text-slate-500">
          <span data-testid={`${testid}-total`}>{total || 0} records</span>
          <div className="flex items-center gap-2">
            <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}>
              <ChevronLeft className="w-4 h-4" />
            </Button>
            <span>Page {page} / {pages}</span>
            <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}>
              <ChevronRight className="w-4 h-4" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
